import styled from 'styled-components'

const PLATFORM_COLORS: Record<string, { bg: string; color: string }> = {
  Twitter: { bg: '#E6F1FB', color: '#185FA5' },
  Instagram: { bg: '#FBEAF0', color: '#993556' },
  Facebook: { bg: '#E6F1FB', color: '#0C447C' },
  YouTube: { bg: '#FCEBEB', color: '#A32D2D' },
}

const GROUP_COLORS: Record<string, { bg: string; color: string }> = {
  blue: { bg: '#E6F1FB', color: '#185FA5' },
  green: { bg: '#EAF3DE', color: '#3B6D11' },
  amber: { bg: '#FAEEDA', color: '#854F0B' },
  pink: { bg: '#FBEAF0', color: '#993556' },
  gray: { bg: '#F1EFE8', color: '#5F5E5A' },
}

export const AccordionContainer = styled.div`
  border: 0.5px solid #e5e5e5;
  border-radius: 10px;
  overflow: visible;
  margin-bottom: 8px;
`

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 16px;
  cursor: pointer;
  background: #fafafa;
  user-select: none;

  &:hover {
    background: #f5f5f5;
  }
`

export const AccordionBody = styled.div`
  border-top: 0.5px solid #eee;
`

export const AvatarCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #e6f1fb;
  color: #185fa5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  flex-shrink: 0;
`

export const NetBadge = styled.span<{ $platform: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 500;
  flex-shrink: 0;
  background: ${({ $platform }) => PLATFORM_COLORS[$platform]?.bg ?? '#f0f0f0'};
  color: ${({ $platform }) => PLATFORM_COLORS[$platform]?.color ?? '#555'};
`

export const GroupPill = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 500;
  background: ${({ $color }) => GROUP_COLORS[$color]?.bg ?? '#f0f0f0'};
  color: ${({ $color }) => GROUP_COLORS[$color]?.color ?? '#555'};
`

export const LinkText = styled.span`
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
`
